import { Component, Inject, Injector } from '@angular/core';
import {
  DataStateChangeEvent,
  GridDataResult,
} from '@progress/kendo-angular-grid';
import {
  GridRowType,
  GridState,
  GridStateCompositeFilterDescriptor,
  LoaderService,
  MessageService,
  ValidationResultService,
} from '@shared';
import { CategoryService, IChangeset } from '@shared-data';
import { RestaurantItemService } from '../../services';
import { BaseAvailabilityChangesetComponent } from '../base-availability-changeset/base-availability-changeset.component';
import {
  CHANGESET_ROW,
  GridRowComboAvailabilityChangeset,
  IAvailabilityItem,
} from '../../models';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-availability-combo-changeset',
  templateUrl: './availability-combo-changeset.component.html',
  styleUrl: './availability-combo-changeset.component.scss',
})
export class AvailabilityComboChangesetComponent extends BaseAvailabilityChangesetComponent {
  constructor(
    validationErrorService: ValidationResultService,
    messageService: MessageService,
    loaderService: LoaderService,
    restaurantItemService: RestaurantItemService,
    categoryService: CategoryService,
    activatedRoute: ActivatedRoute,
    injector: Injector
  ) {
    super(
      validationErrorService,
      messageService,
      loaderService,
      restaurantItemService,
      categoryService,
      activatedRoute,
      injector,
      GridRowComboAvailabilityChangeset,
    );
  }

  override populateGrid(gridDataResult: GridDataResult): void {
    const mainData = gridDataResult.data.filter(
      (row) => row.restaurantId == this.restaurantId,
    );
    const otherData = gridDataResult.data.filter(
      (row) => row.restaurantId != this.restaurantId,
    );

    gridDataResult.data = mainData.map((row: any) => {
      const gridRow = new GridRowComboAvailabilityChangeset(row) as IAvailabilityItem &
        GridRowType &
        IChangeset;

      const itemOtherData = otherData.filter(
        (r) =>
          r.comboParId === row.comboParId && r.entreeParId == row.entreeParId,
      );

      // there is a pending change
      if (
        gridRow.newAvailability != gridRow.isActive ||
        itemOtherData.some((r) => r.newAvailability != null)
      ) {
        gridRow.newAvailability = itemOtherData.every(
          (r) => r.newAvailability == row.newAvailability,
        )
          ? gridRow.newAvailability
          : null;
      } else {
        gridRow.newAvailability = itemOtherData.every(
          (r) => r.isActive == row.isActive,
        )
          ? gridRow.newAvailability
          : null;
      }
      // there is a pending change
      if (
        gridRow.newDeliveryAvailability1P != gridRow.deliveryAvailability1P ||
        itemOtherData.some((r) => r.newDeliveryAvailability1P != null)
      ) {
        //gridRow.isActive = itemOtherData.every(r => r.isActive == row.isActive) ? gridRow.isActive : null;
        gridRow.newDeliveryAvailability1P = itemOtherData.every(
          (r) => r.newDeliveryAvailability1P == row.newDeliveryAvailability1P,
        )
          ? gridRow.newDeliveryAvailability1P
          : null;
      } else {
        //gridRow.isActive = itemOtherData.every(r => r.isActive == row.isActive) ? gridRow.isActive : null;
        gridRow.newDeliveryAvailability1P = itemOtherData.every(
          (r) => r.deliveryAvailability1P == row.deliveryAvailability1P,
        )
          ? gridRow.newDeliveryAvailability1P
          : null;
      }

      // there is a pending change
      if (
        gridRow.newDeliveryAvailability3P != gridRow.deliveryAvailability3P ||
        itemOtherData.some((r) => r.newDeliveryAvailability3P != null)
      ) {
        //gridRow.isActive = itemOtherData.every(r => r.isActive == row.isActive) ? gridRow.isActive : null;
        gridRow.newDeliveryAvailability3P = itemOtherData.every(
          (r) => r.newDeliveryAvailability3P == row.newDeliveryAvailability3P,
        )
          ? gridRow.newDeliveryAvailability3P
          : null;
      } else {
        //gridRow.isActive = itemOtherData.every(r => r.isActive == row.isActive) ? gridRow.isActive : null;
        gridRow.newDeliveryAvailability3P = itemOtherData.every(
          (r) => r.deliveryAvailability3P == row.deliveryAvailability3P,
        )
          ? gridRow.newDeliveryAvailability3P
          : null;
      }

      gridRow.originalValues.set('newAvailability', gridRow.newAvailability);
      gridRow.originalValues.set(
        'newDeliveryAvailability1P',
        gridRow.newDeliveryAvailability1P,
      );
      gridRow.originalValues.set(
        'newDeliveryAvailability3P',
        gridRow.newDeliveryAvailability3P,
      );

      gridRow.locked =
        row.availabilityScheduledDate != null ||
        row.pricingScheduledDate != null ||
        itemOtherData.some(
          (r) =>
            r.availabilityScheduledDate != null ||
            r.pricingScheduledDate != null,
        );

      return gridRow;
    });

    this.changeset = gridDataResult;
  }

  override fetchChangesets(event: GridState | DataStateChangeEvent): void {
    if (event.filter) {
      event.filter = new GridStateCompositeFilterDescriptor(
        GridState.removeFilterByFields(event.filter, 'isActive', 'deliveryAvailability3P', 'deliveryAvailability1P') ??
          new GridStateCompositeFilterDescriptor(),
      );

      event.filter = GridState.substituteFilterField(
        event.filter,
        'newAvailability',
        'isActive',
        'newAvailability',
      );

      event.filter = GridState.substituteFilterField(
        event.filter,
        'newDeliveryAvailability3P',
        'deliveryAvailability3P',
        'newDeliveryAvailability3P',
      );

      event.filter = GridState.substituteFilterField(
        event.filter,
        'newDeliveryAvailability1P',
        'deliveryAvailability1P',
        'newDeliveryAvailability1P',
      );
    }
    super.fetchChangesets(event);
  }
}
